/* src/app/components/service/service-list.component.css */
/*# sourceMappingURL=service-list.component.css.map */
